/* eslint-disable max-len */
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import { StyledText, TextSize } from "./Text";
import { LocationInterface } from "./UtilsComponents";
import CompetencyNavbar from "./CompetencyNavbar";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import Icon from "@mui/material/Icon";
import { UserContext } from "../context/UserContext";
import theme from "../styles/theme";
import { VersionContext } from "../context/VersionContext";

type BlockProps = {
  backgroundColor: string;
};
export const StyledImg = styled.img`
  width: 100%;
  height: 65%;
  max-height: 65%;
  min-height: 65%;
  margin-bottom: 10px;
  border-radius: 5px;
`;
export const CustomBlock = styled(FlexGrow)<BlockProps>`
  margin-bottom: 16px;
  border-radius: 5px;
  text-align: center;
  background: ${({ backgroundColor }) => backgroundColor};
  padding: 16px;
  flex-grow: 0;
  position: relative;
  cursor: pointer;
  width: 171px;
  min-width: 171px;
  max-width: 171px;
  height: 270px;
  min-height: 270px;
  max-height: 270px;
  overflow: hidden;
//   :after {
//     border-bottom: 40px solid transparent;
//     border-left: 20px solid transparent;
//     // border-right: 20px solid;
//     border-image-source: ${({ backgroundColor }) => backgroundColor};
//     border-color: ${({ backgroundColor }) => backgroundColor};
//     content: '';
//     height: 0;
//     position: absolute;
//     top: 3px;
//     width: 0;
//     right: 14px;
//     transform: rotate(315deg);
// }
//   }
//   :before {
//     border-bottom: 40px solid transparent;
//     // border-left: 20px solid;
//     border-image-source: ${({ backgroundColor }) => backgroundColor};
//     border-color: ${({ backgroundColor }) => backgroundColor};
//     border-right: 20px solid transparent;
//     content: '';
//     height: 0;
//     position: absolute;
//     top: 3px;
//     width: 0;
//     left: 14px;
//     transform: rotate(45deg);
//   }
`;
function CompetenciesList() {
  let location = useLocation() as LocationInterface;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { node, id, parent, child } = location.state;
  const [competencies, setCompetencies] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [breadcrumbData, setBreadcrumbData] = useState<any>([]);
  const { user } = useContext(UserContext);
  const { version } = useContext(VersionContext);
  useEffect(() => {
    fetchCompetency(id);
  }, [node, id, location]);
  useEffect(() => {
    updateBreadcrumb(parent, child);
  }, [parent, child]);
  const fetchCompetency = (idString: string) => {
    setLoading(true);
    axios
      .get(
        `/competency/summary?subdomain_id=${idString}&university_code=${version?.university}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        setCompetencies(res.data.competencies);
        setLoading(false);
      })
      .catch((err:any) => {
        setCompetencies(null);
        setLoading(false);
        if (err?.response?.data?.message === "missing or malformed jwt") {
          window.location.pathname="/signin";
          }
      });
  };
  const updateBreadcrumb = (parentData: any, childData: any) => {
    setBreadcrumbData([
      { link: "/view/pillars/child", name: parentData?.label, ...parentData },
      {
        link: "/view/pillars/child/competencies",
        name: childData?.label,
        ...childData,
      },
    ]);
  };
  const redirectToMode = (
    id: string,
    mode: "view" | "edit" | null | string
  ) => {
    if (mode && mode === "edit") {
      return navigate(`/modify/competency/${id}`);
    }
    return navigate(`/view/competency/detail/${id}`);
  };
  return (
    <>
      <CompetencyNavbar breadcrumb={breadcrumbData} />
      {loading ? (
        <LoadingSpinner />
      ) : !competencies ? (
        <FlexBox style={{color:'black'}}>No competency found!</FlexBox>
      ) : (
        <>
          <FlexBox
            space={1}
            style={{
              marginRight: "-16px",
            }}
          >
            {competencies.map((competency: any) => (
              <CustomBlock
                backgroundColor={
                  competency.graphics.iconbg || theme.color.blueButton
                }
                onClick={() => {
                  redirectToMode(
                    competency.competency_code,
                    searchParams.get("mode")
                  );
                }}
              >
                <StyledImg
                  src={
                    process.env.REACT_APP_IMG_URL + competency.graphics.imgurl
                  }
                  alt=""
                />
                <Icon
                  sx={{
                    color: "white",
                    padding: "6px",
                    background: competency.graphics.iconbg,
                    borderRadius: "100px",
                    fontSize: "27px",
                    position: "absolute",
                    bottom: "90px",
                    right: "80px",
                    boxShadow: competency.graphics.iconshadow,
                  }}
                >
                  {competency.graphics.icon}
                </Icon>
                <StyledText fontWeight="700">{competency.title}</StyledText>
                <div>
                  <StyledText fontWeight="300" textSize={TextSize.small}>
                    {competency.description}
                  </StyledText>
                </div>
              </CustomBlock>
            ))}
          </FlexBox>
        </>
      )}
    </>
  );
}
export default CompetenciesList;
